export const NAVS = [
  {
    value: '/pages/index',
    name: 'home',
    label: '首页'
  },
  {
    value: '/pages/cart/espier-index',
    name: 'cart',
    label: '购物车'
  },
  {
    value: '/pages/category/index',
    name: 'category',
    label: '分类'
  },
  {
    value: '/pages/member/index',
    name: 'member',
    label: '我的'
  },
  {
    value: '/pages/recommend/list',
    name: 'article',
    label: '软文'
  },
  {
    value: '/pages/liveroom/index',
    name: 'liveroom',
    label: '直播'
  },
  {
    value: '/pages/item/list?isTabBar=true',
    name: 'allGoods',
    label: '全部商品'
  },
  {
    value: '/subpages/mdugc/index',
    name: 'ugc',
    label: '社区'
  },
  {
    value: 'customPage',
    name: 'customPage',
    label: '自定义页面'
  },
  // {
  //   value: 'purchase',
  //   name: 'purchase',
  //   label: '内购'
  // },
]
